import Vue from 'vue'
var store = require('../store').default

Vue.directive('modal', {
  bind: function (el, { value, rawName, expression, arg }) {
    var modal = rawName.split('.')[1]

    el.setAttribute('style', 'cursor: pointer;')

    el.addEventListener('click', e => {
      e.preventDefault()
    })

    var openModal = () => {
      if (store.getters['modal/activeModal']) {
        store.dispatch('modal/close')
        return
      }

      if (value) {
        store.dispatch('modal/open', {
          name: modal,
          params: value,
          args: arg
        })

        return
      }

      store.dispatch('modal/open', {
        name: modal,
        args: arg
      })
    }

    el.addEventListener('click', openModal)
  }
})
